import { render, staticRenderFns } from "./fullHeight.vue?vue&type=template&id=4578447c&scoped=true&"
var script = {}
import style0 from "./fullHeight.vue?vue&type=style&index=0&id=4578447c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578447c",
  null
  
)

export default component.exports